import axios from 'axios';

export function createInstance(config = {}) {
  const instance = axios.create({
    timeout: 60000,
    ...config,
  });

  // 请求拦截器
  instance.interceptors.request.use(
    (_config) => {
      if (_config.method === 'get') {
        if (!_config.params) {
          _config.params = {};
        }
        _config.params.t = new Date().getTime();
      }
      return _config;
    },
    (error) => Promise.reject(error),
  );

  // 响应拦截器
  instance.interceptors.response.use((response) => {
    const { data, config: _config, request } = response;
    if (data.status === undefined) {
      return Promise.resolve(data);
    }
    if (data.status !== 200) {
      const error = Object.assign(new Error(data.message), {
        config: _config,
        request,
        response,
      });
      return Promise.reject(error);
    }
    return Promise.resolve(data.data);
  },
  (error) => {
    console.error('[Request Error]: ', error);
  });
  return instance;
}
